import React from "react";
import { Monitor, Smartphone } from "lucide-react";
import { HandNote } from "./brand";
import { Interruttore } from "./casella";

const ETICHETTE = { dispositivo: "Dispositivo", computer: "Computer", telefono: "Telefono" };

/**
 * L'anteprima accanto alle impostazioni, uguale nella pagina Widget e in
 * quelle delle app: la nota a mano, la scelta computer / telefono e un
 * riquadro con un sito finto appena accennato. Sopra il sito va cio' che
 * vedra' il visitatore (children), posizionato da chi la usa.
 */
export function CorniceAnteprima({ nota, dispositivo, onDispositivo, etichette = ETICHETTE, piede, id, children }) {
  return (
    <aside className="space-y-2 xl:sticky xl:top-4">
      <div className="flex items-end justify-between gap-3">
        <HandNote>{nota}</HandNote>
        <Interruttore
          etichetta={etichette.dispositivo}
          valore={dispositivo}
          onCambia={onDispositivo}
          voci={[
            { valore: "desktop", etichetta: <Monitor className="h-4 w-4" aria-label={etichette.computer} /> },
            { valore: "mobile", etichetta: <Smartphone className="h-4 w-4" aria-label={etichette.telefono} /> },
          ]}
        />
      </div>
      <div
        id={id}
        className={`relative overflow-hidden rounded-[14px] border border-[#E2E8F0] bg-white shadow-[0_10px_7.5px_rgba(0,0,0,0.05),0_4px_3px_rgba(0,0,0,0.05)] ${
          dispositivo === "desktop" ? "h-[640px]" : "mx-auto h-[640px] w-full max-w-[340px]"
        }`}
      >
        {/* Il "sito" dietro: una pagina finta, appena accennata. */}
        <div className="absolute inset-0 space-y-3 bg-[#F8FAFC] p-6" aria-hidden="true">
          <div className="h-3 w-24 rounded-full bg-[#E2E8F0]" />
          <div className="h-24 rounded-[10px] bg-[#F1F5F9]" />
          <div className="h-2.5 w-3/4 rounded-full bg-[#EEF2F6]" />
          <div className="h-2.5 w-2/3 rounded-full bg-[#EEF2F6]" />
          <div className="h-2.5 w-1/2 rounded-full bg-[#EEF2F6]" />
        </div>
        {children}
      </div>
      {piede ? <div className="space-y-1 px-1 pt-1 text-xs leading-5 text-[#64748B]">{piede}</div> : null}
    </aside>
  );
}
